import useBeneficiaryAccess from '@UI/Hooks/useBeneficiaryAccess';

/** `true` when the caller only sees the dossiers assigned to them: titles then read "MES …". */
const useOwnershipWording = (): boolean => useBeneficiaryAccess().access?.canSupervise !== true;

export default useOwnershipWording;
